// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__5ocsH","info":"Note_info__2gSoi","note":"Note_note__p46Tp","actions":"Note_actions__3U04u"};